import { render, staticRenderFns } from "./ModalBackofficeCaixaCirurgica.vue?vue&type=template&id=64fc247b&scoped=true"
import script from "./ModalBackofficeCaixaCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeCaixaCirurgica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc247b",
  null
  
)

export default component.exports